import { cookies } from '@zing/shared/cookies/behavior'
import { SAVE_HOTSITE_CHALLENGES_DATA, SAVE_HOTSITE_EVENTS_DATA } from './actions'
import { HotsiteChallengeProps, HotsiteEventProps } from './contracts'

const INITIAL_STATE: HotsiteChallengeProps = cookies.get('_eval') ?? {
  rows: []
}

const INITIAL_EVENT_STATE: HotsiteEventProps = cookies.get('_eval') ?? {
  rows: []
}
export interface HotsiteChallengesAction {
  type: string
  payload: any
}

export interface HotsiteEventsAction {
  type: string
  payload: any
}

export const HotsiteChallengesReducer = (state: HotsiteChallengeProps = INITIAL_STATE, action: HotsiteChallengesAction): any => {
  switch (action.type) {
    case SAVE_HOTSITE_CHALLENGES_DATA:
      return {
        ...state,
        rows: action.payload.rows
      }
    default:
      return state
  }
}

export const HotsiteEventsReducer = (state: HotsiteEventProps = INITIAL_EVENT_STATE, action: HotsiteEventsAction): any => {
  switch (action.type) {
    case SAVE_HOTSITE_EVENTS_DATA:
      return {
        ...state,
        rows: action.payload.rows
      }
    default:
      return state
  }
}
